window.Drupal.behaviors.emailRecoveryPassword = {
  attach: (context) => {
    window.addEventListener("DOMContentLoaded", () => {
      // Agrega clases a form
      const form1 = document.querySelector('#user-pass')
      form1.classList.add('recovery-user-form')

      // Agrega clases a los labels
      const labels = document.querySelectorAll('#user-pass label')

      labels.forEach(label => {
        label.classList.add('recovery-user-form--label')
        label.classList.add('m-top')
      })

      // Agrega clase a div del input
      const selectFatherInput = document.querySelector('.recovery-user-form .js-form-item')
      selectFatherInput.classList.add('recovery-user-form--input-wrapper')

      // Agrega clases a los inputs
      const inputs = document.querySelector('#user-pass input')
      inputs.classList.add('recovery-user-form-input')

      // Agrega clases al boton
      const buttonWrapper = document.querySelector('#edit-actions')
      buttonWrapper.classList.add('recovery-user-form-btn--wrapper')

      const button = document.querySelector('#edit-submit2')
      button.classList.add('recovery-user-form-btn')
      button.classList.add('btn-disabled')


      // Agrega clases de error
      setInterval(() => {
        const errorMessages = document.querySelectorAll('#email-error-message')
        const inputsError = document.querySelectorAll('.recovery-user-form-input')

        if (errorMessages.length > 0) {
          inputsError.forEach(input => {
            input.classList.add('input_error')
          })
        }

      }, 100)
    })
  }
}